import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2 } from '@angular/core';

const DEBUG_ALWAYS_SHOW_TOOLTIP = false; // Set to false or remove after debugging

@Directive({
    selector: '[hamDisabledTooltip]',
})
export class HamDisabledTooltipDirective implements AfterViewInit, OnDestroy {
    @Input('hamDisabledTooltip') tooltipText = '';

    private tooltipEl: HTMLElement | null = null;
    private disabledElement: HTMLElement | null = null;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        this.disabledElement = this.findDisabledElement(this.el.nativeElement);

        if (DEBUG_ALWAYS_SHOW_TOOLTIP && this.disabledElement && this.tooltipText) {
            setTimeout(() => this.showTooltip(), 0);
        }
    }

    @HostListener('mouseenter')
    onMouseEnter(): void {
        this.disabledElement = this.findDisabledElement(this.el.nativeElement);
        if (!DEBUG_ALWAYS_SHOW_TOOLTIP) {
            this.showTooltip();
        }
    }

    @HostListener('mouseleave')
    onMouseLeave(): void {
        if (!DEBUG_ALWAYS_SHOW_TOOLTIP) {
            this.destroyTooltip();
        }
    }

    ngOnDestroy(): void {
        this.destroyTooltip();
    }

    private showTooltip(): void {
        if (this.tooltipEl || !this.disabledElement || !this.tooltipText) return;

        this.tooltipEl = this.renderer.createElement('div');
        this.renderer.addClass(this.tooltipEl, 'disabled-tooltip');
        const text = this.renderer.createText(this.tooltipText);
        this.renderer.appendChild(this.tooltipEl, text);

        const arrow = this.renderer.createElement('div');
        this.renderer.addClass(arrow, 'disabled-tooltip-arrow');
        this.renderer.appendChild(this.tooltipEl, arrow);

        this.renderer.appendChild(document.body, this.tooltipEl);

        const hostPos = this.el.nativeElement.getBoundingClientRect();
        const tooltipPos = this.tooltipEl.getBoundingClientRect();

        const top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
        const left = hostPos.left - tooltipPos.width - 10;

        this.renderer.setStyle(this.tooltipEl, 'top', `${top}px`);
        this.renderer.setStyle(this.tooltipEl, 'left', `${left}px`);
    }

    private destroyTooltip(): void {
        if (this.tooltipEl) {
            this.renderer.removeChild(document.body, this.tooltipEl);
            this.tooltipEl = null;
        }
    }

    private findDisabledElement(element: HTMLElement): HTMLElement | null {
        if (element.hasAttribute('disabled')) {
            return element;
        }

        const disabledDescendant = element.querySelector<HTMLElement>('[disabled]');
        return disabledDescendant || null;
    }
}
